<script setup lang="ts">
</script>
<template>
  <div class="flex flex-col gap-1">
    <slot />
  </div>
</template>

<style scoped>
  ::slotted(input) {
    &::placeholder {
      color: var(--black-40);
    }
  }
</style>
